// @flow
import React from "react";
import { localize } from "redux-i18n";
import { GSGrid, View } from "@components";

type Props = $Exact<{
  data: *,
  ...PropsFromLocalize,
}>;

export const ReferralLineManagersTable = ({ data, t }: Props) => (
  <View name="ReferralLineManagersTable" gap={3}>
    <h5>{t("LINE_MANAGERS")}</h5>
    <GSGrid
      rowKeyGetter={row => row.id.id}
      rows={data}
      columns={[
        {
          name: t("FIRST_NAME"),
          key: "firstName",
          align: "left",
        },
        {
          name: t("LAST_NAME"),
          key: "lastName",
          align: "left",
        },
        {
          name: t("WORK_EMAIL"),
          key: "email",
          align: "left",
        },
        {
          name: t("WORK_PHONE"),
          key: "notificationMobile",
        },
      ]}
    />
  </View>
);

export default localize()(ReferralLineManagersTable);
